export function readStringClaim(claims: unknown, key: string): string | null {
  if (typeof claims !== "object" || claims === null || !(key in claims)) {
    return null;
  }

  const value = (claims as Record<string, unknown>)[key];
  return typeof value === "string" && value.length > 0 ? value : null;
}

export function readStringArrayClaim(claims: unknown, key: string): string[] {
  if (typeof claims !== "object" || claims === null || !(key in claims)) {
    return [];
  }

  const value = (claims as Record<string, unknown>)[key];
  return Array.isArray(value) ? value.filter((entry) => typeof entry === "string") : [];
}
